module.exports = __webpack_public_path__ + "img/宣传_186.9d1850be.jpg";